import React from 'react'
import { Alert } from 'react-bootstrap'
import { MdErrorOutline } from 'react-icons/md'
import { useDispatch, useSelector } from 'react-redux'
import { setNotification } from 'application/actions/browserActions'
import { BrowserNotificationStyled } from './browserNotificationStyled'
const BrowserNotification = () => {
  const dispatch = useDispatch()
  const { displayNotification } = useSelector((state) => ({ ...state.browser }))
  const closeNotification = () => {
    dispatch(setNotification(!displayNotification))
  }
  return (
    <BrowserNotificationStyled>
      <Alert variant="danger" onClose={closeNotification} dismissible>
        <MdErrorOutline
          color="#AD240A"
          size={`1.6em`}
          style={{
            minWidth: '20px',
            position: 'absolute',
            left: '6px',
            top: '11px',
          }}
        />
        <div className="text-small ml-3">
          <div className="mb-1">
            <b>
              This website works best in the latest versions of Chrome, Edge,
              Firefox, and similar browsers. You may not have the best
              experience on your current browser or device.
            </b>
          </div>
        </div>
      </Alert>
    </BrowserNotificationStyled>
  )
}

export default BrowserNotification
